import store from '@/store'
import { stockAdjustStatusHistory } from '@/config'
import commonUtil from '@/util/commonUtil'

export default {
  // TODO: 在庫調整履歴の検索項目のステータスと履歴表示のステータスでIDが異なるので
  // 12月以降、サーバ側への仕様確認
  getStockAdjustStatusListForHistorySearch() {
    const ret = this.getStockAdjustStatusListForHistory()
    ret.shift()
    return ret
  },
  getStockAdjustStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      stockAdjustStatusHistory.STATUS,
      stockAdjustStatusHistory.STATUS_HISTORY_LABEL
    )
  },

  getStockAdjustStatusName(status) {
    const ret = this.getStockAdjustStatusList().find(
      (ele) => ele.value === status
    )
    return ret ? ret.label : '-'
  },
  // ステータス履歴表示用に作成必要とのこと
  getStockAdjustStatusNameForHistory(status) {
    const ret = this.getStockAdjustStatusListForHistory().find(
      (ele) => ele.value === status
    )
    return ret ? ret.label : '-'
  },
  getStockAdjustStatusListForHistory() {
    return commonUtil.getStatusHistoryIdNameList(
      stockAdjustStatusHistory.STATUS_FOR_HISTORY,
      stockAdjustStatusHistory.STATUS_HISTORY_LABEL_FOR_HISTORY
    )
  },

  getAdjustReasonById(id) {
    const reasons = store.getters['Common/getStockAdjustReasonListFromState']
    return reasons.find((v) => v.stockAdjustReasonId === id)
  }
}
